export const getListError = (body) => {
  const listKey = Object.keys(body);
  const listError = [];
  listKey.forEach((key) => {
    if (body[key]) {
      listError.push(body[key]);
    }
  });
  return listError;
};

export const validateHttp = (text) => {
  const regex = new RegExp("^(http|https)://", "i");
  return regex.test(text);
};
